import React from "react";

import ListingList from "../components/Listings/ListingList";
import "../assets/styles/listings.scss";

const Listing = (props) => {
  return (
    <section>
      <ListingList />
    </section>
  );
};

export default Listing;
